import { FC } from 'react';
import DropdownSyncTable from '../DropdownSyncTable';
import SimpleFormItem from './subpage/simpleFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { DropdownSyncTableProps } from '../DropdownSyncTable/interface';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
} from './interface';

export interface SimpleFormDropdownSyncTableProps extends BaseSimpleFormProps {
  /** dropdownSyncTable Props */
  dropdownSyncTableProps?: DropdownSyncTableProps;
}
/** 异步下拉表格 */
export const SimpleFormDropdownSyncTable: FC<SimpleFormDropdownSyncTableProps> = props => {
  const {
    dropdownSyncTableProps,
    label,
    rules,
    ...restProps
  } = props;
  return (
    <SimpleFormItem validateTrigger="onChange" label={label} rules={rules} {...restProps}>
      <DropdownSyncTable
        allowClear
        showSearch
        {...dropdownSyncTableProps}
        placeholder={getSelectPlaceholder(label, dropdownSyncTableProps, rules)}
      />
    </SimpleFormItem>
  );
};

SimpleFormDropdownSyncTable.displayName = SimpleFormItemEnum.SimpleFormDropdownSyncTable;

export default SimpleFormDropdownSyncTable;
